export default "__VITE_ASSET__DPB9C419__"